<template>
  <ShipmentEventTimelineItem
    v-if="isShipmentEvent(timelineItem)"
    class="shipment-event-timeline-item"
    :shipment-event="timelineItem"
    :removable="!timelineItem.isMilestone"
    :disabled="disabled"
    :hide-menu="hideMenu"
  />
  <ShipmentServiceIncidentTimelineItem
    v-else-if="isShipmentServiceIncident(timelineItem)"
    class="shipment-event-timeline-item"
    :shipment-service-incident="timelineItem"
    :service-incident-types="serviceIncidentTypes"
    :disabled="disabled"
    :hide-menu="hideMenu"
  />
  <TenderRequestShipmentTimelineItem
    v-else-if="isTenderRequest(timelineItem)"
    class="shipment-event-timeline-item"
    :tender-request="timelineItem"
  />
  <TenderResponseShipmentTimelineItem
    v-else-if="isTenderResponse(timelineItem)"
    class="shipment-event-timeline-item"
    :tender-response="timelineItem"
  />
</template>

<script lang="ts" setup>
import { PropType, toRefs } from 'vue';

import { ServiceIncidentType } from '@rygen/rygen-ui/model';

import {
  ShipmentEvent,
  ShipmentServiceIncident,
  TenderRequest,
  TenderResponse,
  TimelineItem,
} from '@/model';

import ShipmentEventTimelineItem from './ShipmentEventTimelineItem.vue';
import ShipmentServiceIncidentTimelineItem from './ShipmentServiceIncidentTimelineItem.vue';
import TenderRequestShipmentTimelineItem from './TenderRequestShipmentTimelineItem.vue';
import TenderResponseShipmentTimelineItem from './TenderResponseShipmentTimelineItem.vue';

const props = defineProps({
  timelineItem: {
    type: Object as PropType<TimelineItem>,
    required: true,
  },
  serviceIncidentTypes: {
    type: Array as PropType<ServiceIncidentType[]>,
    required: true,
  },
  disabled: {
    type: Boolean,
    default: () => false,
  },
  hideMenu: {
    type: Boolean,
    default: () => false,
  },
});
const { timelineItem, disabled, hideMenu } = toRefs(props);

const isShipmentEvent = (
  timelineItem: TimelineItem,
): timelineItem is ShipmentEvent => {
  return timelineItem instanceof ShipmentEvent;
};

const isShipmentServiceIncident = (
  timelineItem: TimelineItem,
): timelineItem is ShipmentServiceIncident => {
  return timelineItem instanceof ShipmentServiceIncident;
};

const isTenderRequest = (
  timelineItem: TimelineItem,
): timelineItem is TenderRequest => {
  return timelineItem instanceof TenderRequest;
};

const isTenderResponse = (
  timelineItem: TimelineItem,
): timelineItem is TenderResponse => {
  return timelineItem instanceof TenderResponse;
};
</script>
